import { z } from 'zod'
import type { ModelCatalogSnapshot } from '../model/ai-model'
import { aiModelSchema } from '../model/ai-model-schema'

const STORAGE_KEY = 'ai-hub:model-catalog:v5'
export const MODEL_CATALOG_MAX_AGE = 24 * 60 * 60_000

const persistedCatalogSchema = z.object({
  models: z.array(aiModelSchema),
  version: z.string(),
  fetchedAt: z.number(),
})

export function readPersistedModelCatalog(): ModelCatalogSnapshot | undefined {
  try {
    localStorage.removeItem(STORAGE_KEY)
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return undefined
    const parsed = persistedCatalogSchema.safeParse(JSON.parse(raw) as unknown)
    if (!parsed.success || Date.now() - parsed.data.fetchedAt > MODEL_CATALOG_MAX_AGE) {
      sessionStorage.removeItem(STORAGE_KEY)
      return undefined
    }
    return { ...parsed.data, source: 'persisted' }
  } catch {
    sessionStorage.removeItem(STORAGE_KEY)
    return undefined
  }
}

export function persistModelCatalog(snapshot: ModelCatalogSnapshot) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ models: snapshot.models, version: snapshot.version, fetchedAt: snapshot.fetchedAt }))
  } catch {
    // Storage may be unavailable or full. In-memory Query cache remains authoritative.
  }
}

export function clearPersistedModelCatalog() {
  sessionStorage.removeItem(STORAGE_KEY)
  localStorage.removeItem(STORAGE_KEY)
}
